import React from "react";
import { Grid } from "antd";
import { Row, RowProps } from "antd";

import "./styles.scss";
import { getActiveSpan } from "../../utils/ui-manipulations";

const { useBreakpoint } = Grid;

interface CustomRowType extends RowProps {
  children: React.ReactNode;
  isMarginNone?: boolean;
  isEdgeToEdge?: boolean;
}

const CustomRow: React.FC<CustomRowType> = ({
  children,
  isMarginNone,
  isEdgeToEdge,
  ...rest
}) => {
  const childrenArray = React.Children.toArray(children);
  const screens = useBreakpoint();

  if (!isEdgeToEdge) {
    return (
      <Row
        {...rest}
        className={`CustomRow ${rest.className ? rest.className : ""} ${
          isMarginNone ? "CustomRow-no-margin" : ""
        } ${isEdgeToEdge ? "CustomRow-edge-to-edge" : ""}`}
      >
        {children}
      </Row>
    );
  }

  let colSum = 0;
  const enhancedChildren = childrenArray.map((child, idx) => {
    const colProps = (child as any).props;
    const colSpan = getActiveSpan(colProps, screens);

    const isFirst = colSum % 24 === 0;
    colSum += colSpan;
    const isLast = colSum % 24 === 0;

    let className = "";
    if (isFirst) className += " group-first";
    if (isLast) className += " group-last";
    return React.cloneElement(
      child as React.ReactElement<{ className?: string }>,
      {
        className: `${colProps.className || ""}${className}`,
      }
    );
  });

  return (
    <Row
      {...rest}
      className={`CustomRow ${rest.className ? rest.className : ""} ${
        isMarginNone ? "CustomRow-no-margin" : ""
      } ${isEdgeToEdge ? "CustomRow-edge-to-edge" : ""}`}
    >
      {enhancedChildren}
    </Row>
  );
};

export default CustomRow;
